<script>
export default {
  name: "ForbiddenView",
  computed: {
    intendedPage() {
      return this.$route.query?.intended || this.$t('pages.errors.forbidden_view.this_page');
    }
  },
}
</script>
<template>
  <main class="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
    <div class="text-center">
      <p class="text-base font-semibold text-indigo-600">403</p>
      <h1 class="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
        {{ $t('pages.errors.forbidden_view.forbidden') }}
      </h1>
      <p class="mt-6 text-base leading-7 text-gray-600">
        {{
          $t('pages.errors.forbidden_view.sorry_you_do_not_have_any_of_the_necessary_access_rights_to_visit_x', {page: intendedPage})
        }}
      </p>
      <div class="mt-10 flex items-center justify-center gap-x-6">
        <router-link
            :to="{ name: 'home' }"
            class="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          {{ $t('pages.errors.forbidden_view.my_home') }}
        </router-link>
        <a href="#" class="text-sm font-semibold text-gray-900">
          {{ $t('pages.errors.forbidden_view.contact_support') }}
          <span aria-hidden="true">&rarr;</span>
        </a>
      </div>
    </div>
  </main>
</template>


<style scoped>

</style>